/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import About from "./pages/About";
import Company from "./pages/Company";
import MyProfile from "./pages/MyProfile";
import UserProfile from "./pages/UserProfile";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import PrivateRoute from "./components/PrivateRoute";
import ForgotPassword from "./pages/ForgotPassword";
import MyConnections from "./pages/MyConnections";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IntlProvider } from "react-intl";
import messages_en from "./i18n/en.json";
import messages_fr from "./i18n/fr.json";
import messages_es from "./i18n/es.json";
import { useState } from "react";
import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";

const messages: any = {
  en: messages_en,
  fr: messages_fr,
  es: messages_es,
};

function App() {
  let language = navigator.language.split(/[-_]/)[0];
  let currentLocale = "en";
  if (language === "en" || language === "fr" || language === "es")
    currentLocale = language;

  const [locale, setLocale] = useState(currentLocale);

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      <MantineProvider>
        <Router>
          <Header />
          <div className="container">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/company" element={<Company />} />
              <Route path="/userprofile/:id" element={<UserProfile />} />
              <Route path="/myprofile" element={<PrivateRoute />}>
                <Route path="/myprofile" element={<MyProfile />} />
              </Route>
              <Route path="/sign-in" element={<SignIn />} />
              <Route path="/sign-up" element={<SignUp />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="myconnections" element={<PrivateRoute />}>
                <Route path="/myconnections" element={<MyConnections />} />
              </Route>
            </Routes>
          </div>
          <Footer />
        </Router>
        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
      </MantineProvider>
    </IntlProvider>
  );
}

export default App;
